import React, { useState } from 'react';
import NoTrafficModal from './no-traffic/NoTrafficModal';
import Loading from './Loading';
import Table from './Table';

import { ReactComponent as TrafficIcon } from './images/graph.svg';

const NoTraffic = ({entries, setEntries}) => {
  const [selectedEntry, setSelectedEntry] = useState(null);

  if (entries === null) return <Loading />;

  return (
    <>
      {selectedEntry && <NoTrafficModal entry={selectedEntry}
                                        setEntry={setSelectedEntry} />}

      <div style={{width: 'calc(100% - 40px)',
                   overflowY: 'auto',
                   padding: '20px',
                   display: 'flex',
                   flexDirection: 'column',
                   gap: '20px',
                  }}>
        <Table headers={['Name', 'Email', 'Domain', '']}
               contents={entries.map(({ name, email, domain }, id) => {
                 return [name, email, domain,

                         <TrafficIcon style={{width: '20px',
                                              height: '20px',
                                              fill: 'white',
                                              cursor: 'pointer',
                                             }}
                                      onClick={() => setSelectedEntry(entries[id])} />
                        ];
               })}
               proportions={[1, 1, 1, 1]} />
      </div>
    </>
  );
}

export default NoTraffic;
